module.exports = __webpack_public_path__ + "img/p1_l.5d3038ae.jpg";